"use server";

import { redirect } from "next/navigation";
import { cookies } from "next/headers";
import crypto from "crypto";
import bcrypt from "bcryptjs";
import { getDb } from "@/lib/mongodb/client";
import { signToken } from "@/lib/auth/jwt";

export async function signup(formData: FormData): Promise<{ error?: string; success?: boolean; message?: string } | undefined> {
  const email = formData.get("email") as string;
  const password = formData.get("password") as string;

  if (!email || !password) {
    return { error: "Email and password are required" };
  }

  const db = await getDb();
  const normalizedEmail = email.toLowerCase().trim();

  const existingUser = await db.collection("users").findOne({ email: normalizedEmail });
  if (existingUser) {
    return { error: "A user with this email address already exists" };
  }

  const salt = await bcrypt.genSalt(10);
  const passwordHash = await bcrypt.hash(password, salt);

  const userId = crypto.randomUUID();

  const user = {
    id: userId,
    email: normalizedEmail,
    password_hash: passwordHash,
    created_at: new Date(),
  };

  await db.collection("users").insertOne(user);

  const token = signToken({ id: userId, email: normalizedEmail });

  const cookieStore = await cookies();
  cookieStore.set("session", token, {
    httpOnly: true,
    secure: process.env.NODE_ENV === "production",
    maxAge: 60 * 60 * 24 * 7, // 7 days
    sameSite: "lax",
    path: "/",
  });

  // Non-httpOnly copy so the client can read the JWT for Hocuspocus WebSocket auth.
  cookieStore.set("_token", token, {
    httpOnly: false,
    secure: process.env.NODE_ENV === "production",
    maxAge: 60 * 60 * 24 * 7, // 7 days
    sameSite: "lax",
    path: "/",
  });

  cookieStore.set("user", JSON.stringify({ id: userId, email: normalizedEmail }), {
    httpOnly: false, // Client-side readable
    secure: process.env.NODE_ENV === "production",
    maxAge: 60 * 60 * 24 * 7, // 7 days
    sameSite: "lax",
    path: "/",
  });

  redirect("/app");

}
